import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import { Icon } from '@paypalcorp/pp-react'
import { getPopupOptionsString } from 'lib/share'
import {
  shareURLByMessenger,
  shareByTwitter,
  shareByEmail,
  shareBySMS,
} from 'consumerweb-sharing'
import { KEY_PRESS_EVENTS } from 'shared/shared_consts'
import { trackClick } from 'lib/fpti_analytics'
import ClipboardSharingButton from './clipboard_sharing_container'

const { ENTER_KEY } = KEY_PRESS_EVENTS

const i18n = getI18n('components/share_buttons')

const propTypes = {
  showFacebook: PropTypes.bool,
  showMessenger: PropTypes.bool,
  showTwitter: PropTypes.bool,
  showWhatsApp: PropTypes.bool,
  showEmail: PropTypes.bool,
  showSms: PropTypes.bool,
  showClipboard: PropTypes.bool,
  showSubtext: PropTypes.bool,
  shareText: PropTypes.string,
  className: PropTypes.string,
  emailSubject: PropTypes.string,
  emailBody: PropTypes.string,
  shareMsgFB: PropTypes.string,
  shareMsgTwitter: PropTypes.string,
  shareMsgWhatsapp: PropTypes.string,
  shareUrl: PropTypes.string,
}

const handleIconClick = (socialNetwork, props, event) => {
  event.preventDefault()
  const shareText = props.shareText || props.shareUrl
  const charity = props.charity
  const fbUrl = `https://www.facebook.com/dialog/share?app_id=${
    props.appId
  }&display=popup&quote=${props.shareMsgFB}&href=${encodeURI(props.shareUrl)}`
  const whatsappText = props.shareMsgWhatsapp || shareText
  const whatsappUrl =
    `https://${props.isMobile ? 'api' : 'web'}.whatsapp.com/send?text=` +
    encodeURIComponent(whatsappText)
  let clickName = 'social_media'

  switch (socialNetwork) {
    case 'facebook':
      window.open(fbUrl, 'facebook', getPopupOptionsString(640, 480))
      break

    case 'messenger':
      shareURLByMessenger(shareText, props.appId, window.location.href)
      break

    case 'twitter':
      shareByTwitter(props.shareMsgTwitter || shareText, 640, 480)
      break

    case 'whats-app':
      window.open(whatsappUrl)
      break

    case 'email':
      shareByEmail(props.emailSubject, props.emailBody || shareText)
      break

    case 'sms':
      shareBySMS(shareText)
      break

    case 'copy':
      clickName = 'copy'
      break

    default:
      break
  }
  trackClick({
    clickName,
    data: {
      event_name: 'dw_giving_share_channel_pressed',
      link_name: socialNetwork,
      flow:
        charity && charity.name
          ? 'GENEROSITY_NETWORK_CHARITIES'
          : 'GENEROSITY_NETWORK',
      charityname: charity && charity.name,
      crid: charity && charity.nonprofit_id,
    },
  })
}

const handleKeyUp = (socialNetwork, props, event) => {
  if (event.key === ENTER_KEY) {
    handleIconClick(socialNetwork, props, event)
  }
}

const displayComponent = display => {
  if (!display) {
    return
  }
}

export const EmailSharing = props => {
  displayComponent(props.showEmail)

  return (
    <div
      className={props.className}
      onClick={e => handleIconClick('email', props, e)}
      onKeyUp={e => handleKeyUp('email', props, e)}
      tabIndex={0}
    >
      <Icon name="share-email" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('email')}</div>}
    </div>
  )
}

export const TwitterSharing = props => {
  displayComponent(props.showTwitter)

  return (
    <div
      className={props.className}
      onClick={e => handleIconClick('twitter', props, e)}
      onKeyUp={e => handleKeyUp('twitter', props, e)}
      tabIndex={0}
    >
      <Icon name="share-twitter" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('twitter')}</div>}
    </div>
  )
}

export const FacebookSharing = props => {
  displayComponent(props.showFacebook)

  return (
    <div
      className={props.className}
      onClick={e => handleIconClick('facebook', props, e)}
      onKeyUp={e => handleKeyUp('facebook', props, e)}
      tabIndex={0}
    >
      <Icon name="share-facebook" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('facebook')}</div>}
    </div>
  )
}

export const MessengerSharing = props => {
  displayComponent(props.showMessenger)

  return (
    <div
      className={props.className}
      onClick={e => handleIconClick('messenger', props, e)}
      onKeyUp={e => handleKeyUp('messenger', props, e)}
      tabIndex={0}
    >
      <Icon name="share-messenger" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('messenger')}</div>}
    </div>
  )
}

export const WhatsAppSharing = props => {
  displayComponent(props.showWhatsApp)

  return (
    <div
      className={props.className}
      onClick={e => handleIconClick('whats-app', props, e)}
      onKeyUp={e => handleKeyUp('whats-app', props, e)}
      tabIndex={0}
    >
      <Icon name="share-whatsapp" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('whatsapp')}</div>}
    </div>
  )
}

export const SmsSharing = props => {
  displayComponent(props.showSms)

  return (
    <div
      className={props.className}
      onClick={e => handleIconClick('sms', props, e)}
      onKeyUp={e => handleKeyUp('sms', props, e)}
      tabIndex={0}
    >
      <Icon name="share-mobile" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('sms')}</div>}
    </div>
  )
}

export const ClipboardSharing = props => {
  return (
    <ClipboardSharingButton
      handleClick={handleIconClick}
      handleKeyUp={handleKeyUp}
      i18n2={i18n}
      {...props}
    />
  )
}

SmsSharing.propTypes = propTypes
EmailSharing.propTypes = propTypes
TwitterSharing.propTypes = propTypes
WhatsAppSharing.propTypes = propTypes
FacebookSharing.propTypes = propTypes
MessengerSharing.propTypes = propTypes
